import { Button, Dialog, TextField, VideoUploader } from 'src/components';
import { CircularProgress, Grid } from '@material-ui/core';
import { type IS3Response, type IVideo } from 'src/models';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import videoActions from 'src/store/Videos/actions';
import { formatVideoDurationForUpload, getVideoDuration } from 'src/helpers';

interface Props {
	open: boolean;
	handleOpen: () => void;
	isNew: boolean;
	video: IVideo;
}

function VideoDialog({ handleOpen, isNew, open, video }: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const section = useSelector((state: RootState) => state.sections.section);
	const isUploadingVideo = useSelector((state: RootState) => state.sections.isUploadingVideo);

	const [file, setFile] = useState<File>();

	const { handleChange, handleReset, submitForm, setFieldValue, values } =
		useFormik({
			enableReinitialize: true,
			initialValues: isNew
				? {
					description: '',
					key: '',
					name: '',
					sectionId: section.id,
					url: '',
				}
				: video,
			onSubmit: async (values) => {
				if (isNew) {
					const formData = new FormData();
					const duration = await getVideoDuration(file);

					formData.append('file', file!);
					formData.append('name', values.name!);
					formData.append('description', values.description!);
					formData.append('sectionId', values.sectionId);
					formData.append('duration', formatVideoDurationForUpload(duration));
					dispatch(videoActions.create(formData));
				} else {
					dispatch(videoActions.update(values))
				}
			},
		});

	useEffect(() => {
		if (!open) {
			handleReset({});
			setFile(undefined);
		}
	}, [open]);

	return (
		<Dialog
			actions={
				<Button
					actionType={'save'}
					disabled={(isNew
						? values.name?.length === 0 || !file
						: values.name?.length === 0) || isUploadingVideo}
					onClick={submitForm}
					startIcon={isUploadingVideo ? <CircularProgress size={16} /> : undefined}
				>
					Guardar
				</Button>
			}
			content={
				<Grid container spacing={2}>
					{isNew && (
						<Grid item xs={12}>
							<VideoUploader
								onUpload={(file: File) => setFile(file)}
							/>
						</Grid>
					)}

					<Grid item xs={12}>
						<TextField
							label={'Título'}
							name={'name'}
							onChange={handleChange}
							value={values.name}
						/>
					</Grid>

					<Grid item xs={12}>
						<TextField
							label={'Descripción'}
							multiline
							name={'description'}
							onChange={handleChange}
							value={values.description}
						/>
					</Grid>
				</Grid>
			}
			disableClose={isUploadingVideo}
			handleOpen={handleOpen}
			maxWidth={'md'}
			open={open}
			title={isNew ? 'Nuevo Vídeo' : 'Editar Vídeo'}
		/>
	);
}

export default VideoDialog;
